import "./src/styles/global.css"

// or:
// require('./src/styles/global.css')